export default __webpack_public_path__ + "static/media/step4-3.120cf792.jpg";